import {useState, useEffect} from "react";
import {
  ApiResponseFromCMS,
  IClusterDataFromServer,
} from "../pages/Dashboard/Dashboard.type";

const useFetchDataTechClustersAll = (
  apiUrl: string | undefined,
  apiKey: string | undefined
) => {
  const [clusterData, setClusterData] = useState<ApiResponseFromCMS<
    IClusterDataFromServer[]
  > | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // Не выполняем запрос, если нет URL или ключа
    if (!apiUrl || !apiKey) {
      return;
    }

    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const url = new URL(`${apiUrl}`);
    url.searchParams.set("populate", "technologies");
    url.searchParams.set(
      "populate[technologies][filters][$or][0][molecule_only][$eq]",
      "false"
    );
    url.searchParams.set(
      "populate[technologies][filters][$or][1][molecule_only][$null]",
      "true"
    );
    url.searchParams.set("filters[$or][0][molecule_only][$eq]", "false");
    url.searchParams.set("filters[$or][1][molecule_only][$null]", "true");
    url.searchParams.set("pagination[pageSize]", "1000");

    fetch(url.href, {method: "GET", headers})
      .then((response) => response.json())
      .then((data) => {
        setClusterData(data);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrl, apiKey]);

  return {clusterData, error};
};

export default useFetchDataTechClustersAll;
